import { useApi } from "@/hooks/use-api";
import { useAppDispatch, useAppState } from "@/store/useApp";
import { useCallback } from "react";
import { useNavigate } from "react-router";

export const useGenerateReport = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { previewGrading } = useApi();
  const isGeneratingReport = useAppState((state) => state.isGeneratingReport);
  const currentDocument = useAppState((state) => state.currentDocument);

  const isEnabled =
    currentDocument?.suggestions?.some(
      (suggestion) => suggestion.status === "approved"
    ) ?? false;

  const generateReport = useCallback(
    async (documentId: string) => {
      dispatch({ type: "SET_GENERATING_REPORT", payload: true });
      try {
        await previewGrading(documentId);
        navigate(`/documents/${documentId}/grading`);
      } finally {
        dispatch({ type: "SET_GENERATING_REPORT", payload: false });
      }
    },
    [dispatch, navigate, previewGrading]
  );

  return {
    generateReport,
    isEnabled,
    isGeneratingReport,
  };
};

